import React from 'react';
import Navbar from './global-components/navbar';
import JEEDetails from './section-components/jee-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";
import Page_header from './global-components/page-headerjee';

const JEE = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best JEE Coaching in Chennai | MIET Education, Kodambakkam</title>
            <meta name="description" content="MIET Education in Kodambakkam, Chennai, offers best JEE coaching with expert faculty, advanced study materials, and a proven track record of student success." />
        </Helmet>
        {/* <PageHeader headertitle="JEE"  /> */}
        <Page_header headertitle="JEE"/>
        <JEEDetails />
        <Footer />
    </div>
}

export default JEE